// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__38E7i","bigColWidth":"Table_bigColWidth__34n2K","biggerColWidth":"Table_biggerColWidth__TWPp2","row":"Table_row__3ZybF","col":"Table_col__2A2wD"};